/**
 * Central API client – automatically injects the JWT access token
 * from localStorage into every request.
 */

const BASE = process.env.REACT_APP_API_URL || 'https://portfoliotracker-production-5eb2.up.railway.app';
const STORAGE_KEY = 'inverow_auth';

function getToken() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return stored?.accessToken || null;
  } catch {
    return null;
  }
}

export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(`${BASE}${path}`, { ...options, headers });

  // 401 = token expired / invalid – clear stored auth so UI shows login
  if (res.status === 401) {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event('auth:logout'));
  }

  return res;
}

export const API_BASE = `${BASE}/api`;
